export default __webpack_public_path__ + "static/media/graphql.da6f4a75.png";